import keys from '@/config/keys'

export const markLoginWelcomePending = () => {
	sessionStorage.setItem(keys.LOGIN_WELCOME_PENDING, 'true')
}

export const consumePendingLoginWelcome = () => {
	const isPending = sessionStorage.getItem(keys.LOGIN_WELCOME_PENDING) === 'true'

	if (isPending) sessionStorage.removeItem(keys.LOGIN_WELCOME_PENDING)

	return isPending
}
